import React, { useState } from "react";
import {
  Form,
  Button,
  Table,
  Upload,
  Typography,
  Select,
  Input,
  Row,
  Col,
  InputNumber,
  Popconfirm,
  message,
  DatePicker,
  Divider,
  Space,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import Dropzone from "react-dropzone-uploader";
import "react-dropzone-uploader/dist/styles.css";

//Api para mapas
/*AIzaSyCadN8K3_yCdcm9vjrngpEBHMvdydLPt0E*/

//Importaciones para el uso de Redux
import { useDispatch, useSelector } from "react-redux";
import { updateRolEnviromentAction } from "../../../../actions/rolEnviromentActions";
//Styles
import "./CreateAlimentoInv.scss";

// Excel Render
import { ExcelRenderer } from "react-excel-renderer";

// componentes
import FRM from "../../../../utils/FrmService";
import { reloadData } from "../../../../utils/ReloadEnv";
import { showNotification } from "../../../../utils/ShowNotification";
import curStyle from "../../../../css/GlobalCmp.module.css";
import { URL_FILES } from "../../../../constants";
import CST from "../../../../utils/CustomSettings";

export default function CreateDesaparaInv(props) {
  const {
    currentUser,
    closeModal,
    setStateInf,
    currentSetup,
    myNumber,
  } = props;
  const [loadingButton, setLoadingButton] = useState(false);
  const [idOrigen, setIdOrigen] = useState(0);
  const [idProveedor, setIdProveedor] = useState(0);
  const [facturaAlm, setFacturaAlm] = useState("");
  const [numeroLote, setNumeroLote] = useState("");
  const [idVacuna, setIdVacuna] = useState(0);
  const [importe, setImporte] = useState("");
  const [cantidad, setCantidad] = useState(0);
  const [dosis, setDosis] = useState(0);
  const [precioUnd, setPrecioUnd] = useState(0);
  const [precioHumedo, setPrecioHumedo] = useState(0);
  const [precioSeco, setPrecioSeco] = useState(0);
  const [nota, setNota] = useState("");
  const [fechaEntr, setFechaEntr] = useState(null);
  const [fechaVence, setFechaVence] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [nameAdjunto, setNameAdjunto] = useState("");

  const { Option } = Select;
  const [form] = Form.useForm();

  const vacunasList = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.antiparasita
  );

  //Listado de proveedores
  const suppliersList = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.servicios
  );

  const openAdjunto = (pdf_file) => {
    //Url para visaulizacion del PDF Temporal
    const url_temp = URL_FILES + currentUser.dominio + "/temporal/" + pdf_file;
    window.open(`${url_temp}`);
  };

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const { Title } = Typography;
  const { TextArea } = Input;

  //Cambio de fecha
  function onChangeFecha(date, dateString) {
    setFechaEntr(dateString);
  }

  //Cambio de fecha
  function onChangeVence(date, dateString) {
    setFechaVence(dateString);
  }

  //Se actualiza el nombre
  const updateVacuna = async (value) => {
    setIdVacuna(value);
    setCantidad(0);
    setPrecioUnd(0);
    setDosis(0);
  };

  //Se actualiza el nombre
  const updateProveedor = async (value) => {
    setIdProveedor(value);
  };

  const onChangeFact = (e) => {
    const facCnc = e.target.value;
    setFacturaAlm(facCnc.toUpperCase());
  };

  const onChangeLote = (e) => {
    const facCnc = e.target.value;
    setNumeroLote(facCnc.toUpperCase());
  };

  const onChangeUnd = (value) => {
    if (Number.parseInt(idVacuna) > 0) {
      if (Number.parseFloat(value) >= 0) {
        setCantidad(value);
        setPrecioUnd(0);
        setDosis(0);
      } else {
        message.error("VALOR INCORRECTO!", 1);
        return false;
      }
    } else {
      message.error("SELECCIONE EL TIPO DE VACUNA!", 1);
      return false;
    }
  };

  const onChangeDss = (value) => {
    if (Number.parseInt(idVacuna) > 0) {
      if (Number.parseFloat(value) >= 0) {
        setDosis(value);
      } else {
        message.error("VALOR INCORRECTO!", 1);
        return false;
      }
    } else {
      message.error("SELECCIONE EL TIPO DE VACUNA!", 1);
      return false;
    }
  };

  const onChangePU = (value) => {
    if (Number.parseFloat(value) >= 0) {
      setPrecioUnd(value);
    } else {
      message.error("VALOR INCORRECTO!", 1);
      return false;
    }
  };

  const onChangeNota = (e) => {
    const notaE = e.target.value;
    setNota(notaE.toUpperCase());
  };

  //GESTION DE CARGAR DE ARCHIVOS PDF
  // specify upload params and url for your files
  const getUploadParams = ({ file, meta }) => {
    const body = new FormData();
    body.append("file", file);
    const headers = new Headers();
    headers.append("accept", "application/json");
    return { url: "https://api.aal-erp.com/frm/api/712", body, headers };
  };

  // called every time a file's `status` changes
  //const handleChangeStatus = ({ meta, file }, status) => { console.log(status, meta, file) }
  const handleChangeStatus = ({ meta, remove }, status) => {
    console.log(meta);
    if (status === "headers_received") {
      setNameAdjunto(meta.name);
      message.success("CARGA DE ADJUNTO EXITOSA", 1);
      //alert(`${meta.name} uploaded!`);
      remove();
    } else if (status === "aborted") {
      message.error("CARGA DE ADJUNTO FALLIDA", 2);
    }
  };
  //FIN GESTION DE CARGA DE ARCHIVOS

  // ENVIO A WEBSERVICES
  const uploadDspWS = async () => {
    setLoadingButton(true);
    if (
      Number.parseInt(idVacuna) === 0 ||
      Number.parseFloat(cantidad) === 0 ||
      Number.parseFloat(dosis) === 0 ||
      Number.parseFloat(precioUnd) === 0 ||
      fechaEntr.length === 0 ||
      fechaVence.length === 0
    ) {
      showNotification(
        "topRight",
        2,
        "COMPRA DE VACUNAS",
        "LOS DATOS ESTAN INCOMPLETOS PARA EL REGISTRO"
      );
    } else {
      let record = {
        tipoMov: 5,
        usr_id: currentUser.id,
        trc_id: idProveedor,
        factura: facturaAlm,
        id: idVacuna,
        cantidad: cantidad,
        dosis: dosis,
        precio_unt: precioUnd,
        lote: numeroLote,
        vence: fechaVence,
        nota: nota,
        fecha: fechaEntr,
        adjunto: nameAdjunto.length === 0 ? "NA" : nameAdjunto,
      };
      var val_inventory = await FRM.sendAlimento(currentUser, record);
      if (val_inventory.type && Number.parseInt(val_inventory.type) > 0) {
        updateEnviroment(val_inventory.datos.rol_entorno);
        setStateInf(Math.random());
        showNotification(
          "topRight",
          4,
          "ANTIPARASITARIOS",
          "PROCESO DE REGISTRO EXITOSO"
        );
      } else {
        showNotification(
          "topRight",
          2,
          "COMPRA DE ANTIPARASITARIO",
          val_inventory.message
        );
      }
    }
    setFileList([]);
    setLoadingButton(false);
    closeModal();
  };

  return (
    <div className="upload-panel">
      <Title level={3} style={{ textAlign: "center" }}>
        {"REGISTRAR ENTRADA DE ANTIPARASITARIO"}
      </Title>
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item label="Fecha de Entrada">
              <DatePicker onChange={onChangeFecha} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Proveedor que Suministra">
              <Select
                showSearch
                showArrow
                style={{ width: "100%" }}
                defaultValue={
                  idProveedor > 0 ? idProveedor : "SELECCIONE PROVEEDOR"
                }
                placeholder="PROVEEDOR"
                onChange={updateProveedor}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {suppliersList.map((proveedor) => (
                  <Option key={proveedor.trc_id} value={proveedor.trc_id}>
                    {proveedor.trc_nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Numero Factura">
              <Input
                placeholder="Factura"
                defaultValue={""}
                style={{ width: "100%" }}
                value={facturaAlm}
                onChange={onChangeFact}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={14}>
            <Form.Item label="Tipo de Medicamento">
              <Select
                showSearch
                showArrow
                style={{ width: "100%" }}
                defaultValue={
                  idVacuna === 0
                    ? "SELECCIONE TIPO DE ANTIPARASITARIO"
                    : idVacuna
                }
                placeholder="MEDICAMENTO COMPRADA"
                onChange={updateVacuna}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {vacunasList.map((vacuna) => (
                  <Option key={vacuna.id} value={vacuna.id}>
                    {vacuna.atp_nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Numero Lote">
              <Input
                placeholder="Lote"
                defaultValue={""}
                style={{ width: "100%" }}
                value={numeroLote}
                onChange={onChangeLote}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Vencimiento">
              <DatePicker onChange={onChangeVence} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="UNIDADES">
              <InputNumber
                style={{
                  width: "100%",
                  textAlign: "right",
                  color: "orangered",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                min={0}
                defaultValue={cantidad}
                value={cantidad}
                onChange={onChangeUnd}
                placeholder="Fardos"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="COSTO UND">
              <InputNumber
                style={{
                  width: "100%",
                  textAlign: "right",
                  color: "orangered",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                min={0}
                defaultValue={precioUnd}
                value={precioUnd}
                onChange={onChangePU}
                placeholder="Costo"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Nº DE DOSIS">
              <InputNumber
                style={{
                  width: "100%",
                  textAlign: "right",
                  color: "orangered",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                min={0}
                defaultValue={dosis}
                value={dosis}
                onChange={onChangeDss}
                placeholder="Fardos"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row style={{ marginTop: 10 }}>
        <Col span={24}>
          <TextArea
            rows={2}
            value={nota}
            placeholder={"Observaciones"}
            onChange={onChangeNota}
            allowClear
          />
        </Col>
      </Row>
      <Divider style={{ marginTop: 15, paddingTop: 10, marginBottom: 5 }}>
        {"Comprobante de respaldo"}
      </Divider>
      {nameAdjunto.length > 0 ? (
        <Button
          type="link"
          size="large"
          onClick={() => openAdjunto(nameAdjunto)}
        >
          {nameAdjunto}
        </Button>
      ) : null}
      <div
        style={{
          textAlign: "center",
          marginTop: 20,
          border: 0,
        }}
      >
        <Dropzone
          getUploadParams={getUploadParams}
          onChangeStatus={handleChangeStatus}
          autoUpload={true}
          maxFiles={1}
          multiple={false}
          canCancel={false}
          accept=".pdf"
          inputContent={"Arrastre o seleccione el PDF a adjuntar"}
          inputWithFilesContent={"Agregar Archivos"}
          submitButtonContent={"Subir Archivos"}
        />
      </div>
      <div style={{ display: "flex", alignContent: "left", marginTop: 5 }}>
        <Popconfirm
          placement="top"
          title="CONFIRMAR EL MOVIMIENTO?"
          onConfirm={() => uploadDspWS()}
          okText="Si"
          cancelText="No"
        >
          <Button
            type="primary"
            className={curStyle.btnWarning}
            shape="round"
            block
            loading={loadingButton}
          >
            <UploadOutlined /> PROCESAR COMPRA DE ANTIPARASITARIO
          </Button>
        </Popconfirm>
      </div>
    </div>
  );
}
